/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input, ModalComp } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DeleteSellingProduct,
  GetSellingProductDetails,
  UpadateSellingProductDetails,
} from "../../../utilities/api/stock/sell";
import { toast } from "react-toastify";
import {
  getPercentValue,
  handleCgstChange,
  handleIgstChange,
  handleSgstChange,
  numberValidation,
} from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.stocks;

const UpdateSellingInventory = () => {
  const id = useLocation().state;
  const navigate = useNavigate();
  const [data, setData] = useState<any>({});
  const [igst, setIgst] = useState<number | string>("");
  const [sgst, setSgst] = useState<number | string>("");
  const [cgst, setCgst] = useState<number | string>("");
  const [sellingPrice, setSellingPrice] = useState<number>(0);
  const [availableQuantity, setAvailableQuantity] = useState<number>(0);
  const [remarkText, setRemarkText] = useState("");
  const [hsnNumber, setHsnNumber] = useState("");
  const [isActive, setIsActive] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    igst: "",
    cgst: "",
    sgst: "",
    remarkText: "",
    availableQuantity: "",
    sellingPrice: "",
    hsnNumber: "",
    isActive: "",
  });
  const [archive, setArchive] = useState(false);

  const GetData = async () => {
    const result = await GetSellingProductDetails(id);
    if (result.statusCode === 200) {
      let SellData = result.data;
      setData({
        name: SellData.name,
        soldQuantity: SellData.soldQuantity,
        availableQuantity: SellData.availableQuantity,
        costPrice: SellData.costPrice,
      });
      setHsnNumber(SellData.hsnNumber);
      setIgst(
        SellData.sellingProductTaxes?.filter(
          (item: any) => item.tax.id === 1
        )[0]?.percentage
      );
      setCgst(
        SellData.sellingProductTaxes?.filter(
          (item: any) => item.tax.id === 2
        )[0]?.percentage
      );
      setSgst(
        SellData.sellingProductTaxes?.filter(
          (item: any) => item.tax.id === 3
        )[0]?.percentage
      );
      setSellingPrice(SellData.sellingPrice);
      setAvailableQuantity(SellData.availableQuantity);
      setIsActive(`${SellData.isActive}`);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const validate = () => {
    let Igst = Number(igst);
    let Cgst = Number(cgst);
    let Sgst = Number(sgst);

    if (
      Igst <= 0 ||
      Cgst <= 0 ||
      Sgst <= 0 ||
      !isActive ||
      (availableQuantity !== data.availableQuantity &&
        remarkText.length <= 0) ||
      availableQuantity <= 0 ||
      sellingPrice <= 0 ||
      hsnNumber.length < 6 ||
      hsnNumber.length > 8
    ) {
      setErrorMessage({
        igst:
          Igst <= 0
            ? getMessage.IGST_required
            : numberValidation(Igst) != null
              ? ""
              : getMessage.IGST_valueType,
        cgst:
          Cgst <= 0
            ? getMessage.CGST_required
            : numberValidation(Cgst) != null
              ? ""
              : getMessage.CGST_valueType,
        sgst:
          Sgst <= 0
            ? getMessage.SGST_required
            : numberValidation(Sgst) != null
              ? ""
              : getMessage.SGST_valueType,
        remarkText:
          availableQuantity !== data.availableQuantity && remarkText.length <= 0
            ? getMessage.remarkText_required
            : "",
        availableQuantity: availableQuantity <= 0 ? getMessage.availableQuantity_required : "",
        sellingPrice: sellingPrice <= 0 ? getMessage.sellingPrice_required : "",
        hsnNumber:
          hsnNumber.length < 6 || hsnNumber.length > 8
            ? getMessage.hsnNumber_min_max_length
            : "",
        isActive: isActive.length === 0 ? getMessage.status_required : "",
      });
      return false;
    } else {
      setErrorMessage({
        igst: "",
        cgst: "",
        sgst: "",
        remarkText: "",
        availableQuantity: "",
        sellingPrice: "",
        hsnNumber: "",
        isActive: "",
      });
      return true;
    }
  };

  const handleCancel = () => {
    navigate("/sell-stock");
  };

  const onSubmit = async () => {
    if (validate()) {
      const payload = {
        costPrice: data.costPrice,
        sellingPrice: Number(sellingPrice),
        availableQuantity: availableQuantity,
        hsnNumber: hsnNumber,
        igst: Number(igst),
        cgst: Number(cgst),
        sgst: Number(sgst),
        remarkText: remarkText,
        isActive: isActive,
      };
      const result = await UpadateSellingProductDetails(id, payload);
      if (result.status === 200) {
        navigate("/sell-stock");
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  const handleDelete = async () => {
    const result = await DeleteSellingProduct(id);
    if (result.status === 200) {
      navigate("/sell-stock");
    } else {
      toast.error(result.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">Edit or Remove Sales Stock</Card.Title>
              <ButtonGroup>
                <Button
                  onClick={() => setArchive(true)}
                  type="button"
                  bname="Delete Inventory"
                  name="delete-inventory"
                  id="delete-inventory"
                  className="btn btn-primary rounded-1"
                ></Button>
              </ButtonGroup>
            </div>
            <hr />
            <Row className="text-start">
              <Col lg={5}>
                <div className="fw-semibold mb-3">
                  Product Name: <span className="text-info">{data?.name}</span>{" "}
                </div>
              </Col>
              <Col lg={3}>
                <div className="fw-semibold mb-3">
                  Sold Today: <span className="text-info">{data.soldQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4}>
                <div className="fw-semibold mb-3">
                  Purchased Price per Unit:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span> {data.costPrice?.toFixed(2)}
                  </span>{" "}
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={6}>
                <div className="align-items-baseline d-flex mb-3 text-start">
                  <label htmlFor="availableQuantity" className="form-label">
                    Available Quantity :{" "}
                  </label>
                  <div className="ms-3 quantity-input">
                    <span
                      className="minus"
                      onClick={() => availableQuantity > 0 && setAvailableQuantity(pre => pre - 1)}
                    >
                      -
                    </span>
                    <Input
                      value={availableQuantity}
                      type="text"
                      className="form-control"
                      id="availableQuantity"
                      name="availableQuantity"
                      onChange={(e: any) => setAvailableQuantity(Number(e.target.value))}
                    />
                    <span className="plus" onClick={() => setAvailableQuantity(pre => pre + 1)}>
                      +
                    </span>
                    <span className="error-msg">{errorMessage.availableQuantity}</span>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="remarkText" className="form-label">
                    Remark if quantity Change <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={remarkText}
                    type="text"
                    placeholder=""
                    className="form-control"
                    id="remarkText"
                    name="remarkText"
                    onChange={(e: any) => setRemarkText(e.target.value)}
                  />
                  <span className="error-msg">{errorMessage.remarkText}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="sellingPrice" className="form-label">
                    Selling Price Per Unit <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={sellingPrice}
                    type="text"
                    placeholder=""
                    className="form-control"
                    id="sellingPrice"
                    name="sellingPrice"
                    onChange={(e: any) => {
                      if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                        setSellingPrice(e.target.value);
                      }
                    }}
                    onKeyDown={(e: any) => e.key === "e" && e.preventDefault()}
                  />
                  <span className="error-msg">{errorMessage.sellingPrice}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="hsnNumber" className="form-label">
                    HSN Number <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={hsnNumber}
                    type="number"
                    placeholder="Enter HSN Number"
                    id="hsnNumber"
                    name="hsnNumber"
                    className="form-control"
                    onChange={(e: any) => setHsnNumber(e.target.value)}
                    onKeyDown={(e: any) => {
                      if (["e", ".", "-", "+"].includes(e.key)) e.preventDefault();
                      const val = e.target.value;
                      if (val.length >= 8 && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") e.preventDefault();
                    }}
                  />
                  <span className="error-msg">{errorMessage.hsnNumber}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="igst" className="form-label">
                    IGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="number"
                    placeholder="Enter IGST"
                    id="igst"
                    name="igst"
                    className="form-control"
                    value={igst}
                    onChange={(e: any) => handleIgstChange(e, setIgst, setCgst, setSgst)}
                  />
                  <span className="error-msg">{errorMessage.igst}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="cgst" className="form-label">
                    CGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="number"
                    placeholder="Enter CGST"
                    id="cgst"
                    name="cgst"
                    className="form-control"
                    value={cgst}
                    onChange={(e: any) => handleCgstChange(e, setIgst, setCgst, sgst)}
                  />
                  <span className="error-msg">{errorMessage.cgst}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="sgst" className="form-label">
                    SGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="number"
                    placeholder="Enter SGST"
                    id="sgst"
                    name="sgst"
                    className="form-control"
                    value={sgst}
                    onChange={(e: any) => handleSgstChange(e, setIgst, cgst, setSgst)}
                  />
                  <span className="error-msg">{errorMessage.sgst}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="facilityname" className="form-label">
                    Status <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    value={isActive}
                    onChange={(e: any) => setIsActive(e.target.value)}
                    name="isActive"
                    id="isActive"
                    className="form-control"
                  >
                    <option hidden disabled value="">
                      Select Facility Status
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </DropDown>
                  <span className="error-msg">{errorMessage.isActive}</span>
                </div>
              </Col>
              <Col lg={8} className="align-self-end">
                <div className="badge bg-primary fs-6 fst-italic fw-semibold mb-0 mb-3 p-2">
                  Selling Price Per Unit: <span className="rupees-symbol">&#8377;</span>{" "}
                  {(
                    Number(sellingPrice) + getPercentValue(Number(sellingPrice), Number(igst))
                  )?.toFixed(2)}
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <Button
                  onClick={handleCancel}
                  type="button"
                  bname="Cancel"
                  name="cancel"
                  id="cancel"
                  className="btn btn-light rounded-1 me-3"
                ></Button>
                <Button
                  onClick={onSubmit}
                  type="button"
                  bname="Update"
                  name="update"
                  id="update"
                  className="btn btn-primary rounded-1 "
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ModalComp archive={archive} setArchive={setArchive} handleDelete={handleDelete} />
    </>
  );
};
export { UpdateSellingInventory };
